import type { LlmStatsResponseDto } from '@lunary/api-client'
import { Kpi } from '../../shared/ui/charts/kpi'
import { formatNumber } from '../../shared/ui/charts/scale'
import { StackedBars } from '../../shared/ui/charts/stacked-bars'
import { PURPOSE_LABELS, indexBy, percent, purposeSeries } from './series'
import styles from './overview.module.css'

export function LlmSection({ data, days }: { data: LlmStatsResponseDto; days: readonly string[] }) {
  const series = purposeSeries(data.by_day.map((r) => r.purpose))
  const calls = indexBy(data.by_day, (r) => r.purpose, (r) => r.calls)
  const total = data.by_model.reduce(
    (acc, r) => ({ calls: acc.calls + r.calls, tokens: acc.tokens + r.tokens_in + r.tokens_out, cost: acc.cost + r.cost_rub }),
    { calls: 0, tokens: 0, cost: 0 },
  )
  const votes = data.likes + data.dislikes

  return (
    <section className={styles.section} aria-labelledby="ov-llm">
      <h2 id="ov-llm">LLM и эксперт</h2>
      <div className={styles.kpis}>
        <Kpi label="Вызовов LLM" value={formatNumber(total.calls)} />
        <Kpi label="Токенов" value={formatNumber(total.tokens)} />
        <Kpi
          label="Стоимость"
          value={data.pricing_configured ? `${formatNumber(total.cost, 2)} ₽` : '—'}
          hint={data.pricing_configured ? undefined : 'Цены не заданы в env'}
        />
        <Kpi label="Лайки" value={votes > 0 ? percent(data.likes, votes) : '—'} hint={`лайков ${data.likes}, дизлайков ${data.dislikes}`} />
        <Kpi label="Разборы ждут" value={formatNumber(data.queue_pending)} hint={`закрыто за период: ${data.queue_closed}`} />
        <Kpi
          label="Среднее время ответа"
          value={data.avg_answer_hours === null ? '—' : `${formatNumber(data.avg_answer_hours, 1)} ч`}
        />
      </div>
      <div className={styles.split}>
        <div className="card-panel">
          <p className={styles.caption}>Вызовы по дням и назначению</p>
          <StackedBars label="Вызовы LLM по дням" days={days} series={series} value={calls} height={200} />
        </div>
        <div className="card-panel" style={{ overflowX: 'auto' }}>
          <p className={styles.caption}>По моделям</p>
          <table className="users-table">
            <thead>
              <tr>
                <th>Модель</th>
                <th>Назначение</th>
                <th>Вызовы</th>
                <th>Токены</th>
                {data.pricing_configured && <th>₽</th>}
              </tr>
            </thead>
            <tbody>
              {data.by_model.map((r) => (
                <tr key={`${r.model}|${r.purpose}`}>
                  <td>{r.model}</td>
                  <td>{PURPOSE_LABELS[r.purpose] ?? r.purpose}</td>
                  <td>{formatNumber(r.calls)}</td>
                  <td>{formatNumber(r.tokens_in + r.tokens_out)}</td>
                  {data.pricing_configured && <td>{formatNumber(r.cost_rub, 2)}</td>}
                </tr>
              ))}
            </tbody>
          </table>
          {data.by_model.length === 0 && <p className="muted">За период вызовов не было.</p>}
        </div>
      </div>
    </section>
  )
}
